<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "Financing"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/Financing.vue